import {
  compareTimelineTimes,
  getTimelineDeltaMs,
  LogLineSource,
  parseTimelineTime,
  TimelineTime,
} from './log-timeline';

export type StepDeltaEvent = {
  id: string;
  timestamp?: string;
  source?: LogLineSource;
};

export const getTaskStartTimes = (
  events: { taskId: string; timestamp: string }[],
) => {
  const starts = new Map<string, TimelineTime>();
  for (const event of events) {
    const start = parseTimelineTime(event.timestamp);
    if (!start) {
      continue;
    }
    const previous = starts.get(event.taskId);
    if (!previous || compareTimelineTimes(start, previous) < 0) {
      starts.set(event.taskId, start);
    }
  }
  return starts;
};

export const getStepDeltas = (events: StepDeltaEvent[]) => {
  const deltas = new Map<string, number | null>();
  events.forEach((event) => deltas.set(event.id, null));

  const chronological = events
    .map((event) => ({
      id: event.id,
      time: parseTimelineTime(event.timestamp),
    }))
    .filter((event): event is { id: string; time: TimelineTime } =>
      Boolean(event.time),
    )
    .sort((left, right) => {
      const time = compareTimelineTimes(left.time, right.time);
      return time || left.id.localeCompare(right.id);
    });

  chronological.slice(1).forEach((event, index) => {
    const previous = chronological[index];
    deltas.set(event.id, getTimelineDeltaMs(event.time, previous.time));
  });

  return deltas;
};
